export const configProspectReport = (tab) => [
  { name: 'namaSalesmanCS', label: 'Nama Salesman / CS', options: { sort: false, display: tab === 'salesman' } },
  { name: 'namaTeamLead', label: 'Nama TL', options: { sort: false, display: tab !== 'salesman' } },
  { name: 'newProspect', label: 'New Prospek', options: { sort: false } },
  { name: 'newProspectRate', label: 'rate %', options: { sort: false } },
  { name: 'nonFU', label: 'Non F U', options: { sort: false } },
  { name: 'nonFURate', label: 'rate %', options: { sort: false } },
  { name: 'ongoing', label: 'Ongoing', options: { sort: false } },
  { name: 'ongoingRate', label: 'rate %', options: { sort: false } },
  { name: 'pending', label: 'Pending', options: { sort: false } },
  { name: 'pendingRate', label: 'rate %', options: { sort: false } },
  { name: 'deal', label: 'Deal', options: { sort: false } },
  { name: 'dealRate', label: 'rate %', options: { sort: false } },
  { name: 'drop', label: 'Drop', options: { sort: false } },
  { name: 'dropRate', label: 'rate %', options: { sort: false } }
]
;

export const configAppointmentReport = [
    {name: "salesName", label: "Nama Salesman/CS", options: {sort: false}},
    {name: "customerName", label: "Nama Konsumen", options: {sort: false}},
    {name: "address", label: "Alamat", options: {sort: false}},
    {name: "kecamatan", label: "Kecamatan", options: {sort: false}},
    {name: "noHp1", label: "No Hape 1", options: {sort: false}},
    {name: "noHp2", label: "No Hape 2", options: {sort: false}},
];

export const configOverdue = [
    {name: "overdue", label: "Overdue", options: {sort: false}},
];

export const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});
